var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.pinnedMenuItems.length)?[_c('li',{staticClass:"nav-item sidebar-section-title"},[_c('span',{staticClass:"nav-link-text"},[_vm._v(_vm._s(_vm.$t('menu.pinned_section')))])]),_vm._l((_vm.pinnedMenuItems),function(pin){return _c('sidebar-item',{key:'pinned-' + pin.key,attrs:{"link":{ name: pin.name, icon: pin.icon, path: pin.path }}},_vm._l((pin.children),function(child){return _c('sidebar-item',{key:'pinned-' + pin.key + '-' + child.key,attrs:{"link":{ name: _vm.$t(child.i18n), path: child.path }}},_vm._l(((child.children || [])),function(grandchild){return _c('sidebar-item',{key:'pinned-' + pin.key + '-' + child.key + '-' + grandchild.key,attrs:{"link":{ name: _vm.$t(grandchild.i18n), path: grandchild.path }}})}),1)}),1)}),_c('li',{staticClass:"nav-item sidebar-section-divider"},[_c('hr',{staticClass:"my-2"})])]:_vm._e(),((_vm.isAccessPayment || _vm.isAccessDashboardByPlatformChannel) && _vm.menuShow('menu_dashboard'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_dashboard,
                        icon: 'fa fa-chart-pie text-primary',
                        path: '/backoffice/reports/dashboard'
                    }}},[(_vm.isAccessPayment)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_dashboard_team, icon: 'fa fa-users text-primary', path: '/backoffice/reports/dashboard' }}}):_vm._e(),(_vm.isAccessDashboardByPlatformChannel)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_dashboard_platform, icon: 'fa fa-chart-bar text-primary', path: '/backoffice/reports/dashboard-by-platform-channel' }}}):_vm._e()],1):_vm._e(),(_vm.isAccessOrder && _vm.menuShow('menu_order_form'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_order_form,
                        icon: 'fa fa-shopping-cart text-blue',
                        path: '/backoffice/orders/create'
                    }}}):_vm._e(),(_vm.isAccessOrder && _vm.menuShow('menu_order'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_order,
                        icon: 'fa fa-tasks text-primary',
                        path: '/backoffice/orders'
                    }}}):_vm._e(),(_vm.isAccessOrder && _vm.isMdfStaff && _vm.isAccessOrderOverview && _vm.menuShow('menu_order_new'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_order_new,
                        icon: 'fa fa-list-alt text-info',
                        path: '/backoffice/orders-overview'
                    }}}):_vm._e(),(_vm.isAdmin && _vm.menuShow('menu_order_reprocess'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_order_reprocess,
                        icon: 'fa fa-sync text-warning',
                        path: '/backoffice/orders/reprocess'
                    }}}):_vm._e(),(_vm.isAccessOrder && _vm.menuShow('menu_available_stock'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_available_stock,
                        icon: 'fa fa-cubes text-info',
                        path: '/backoffice/available-stock'
                    }}}):_vm._e(),(_vm.isAccessPayment && _vm.menuShow('menu_payment'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_payment,
                        icon: '	fab fa-btc text-red',
                        path: '/backoffice/payments'
                    }}}):_vm._e(),(_vm.isAccessPacking && _vm.menuShow('menu_packing'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_packing,
                        icon: 'fa fa-car text-primary',
                        path: '/backoffice/packings'
                    }}}):_vm._e(),(_vm.isAccessOrderReturn && _vm.menuShow('menu_order_return'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_order_return,
                        icon: 'fa fa-car text-red',
                        path: '/backoffice/packings/shipping/return'
                    }}}):_vm._e(),(_vm.isAccessCoupon && _vm.menuShow('menu_coupon'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_coupon,
                        icon: 'fa fa-columns',
                        path: '/backoffice/coupon'
                    }}}):_vm._e(),(_vm.isAccessPlatformStatement && _vm.menuShow('menu_platform_statement'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_platform_statement,
                        icon: 'fa fa-file-invoice text-success',
                        path: '/backoffice/platform-statement'
                    }}},[(_vm.isAccessPlatformStatement)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_platform_statement_list, icon: 'fa fa-list', path: '/backoffice/platform-statement' }}}):_vm._e(),(_vm.isAccessPlatformStatement)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_platform_statement_upload, icon: 'fa fa-upload', path: '/backoffice/platform-statement/upload' }}}):_vm._e(),(_vm.isAccessPlatformStatement)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_platform_statement_summary, icon: 'fa fa-chart-bar', path: '/backoffice/platform-statement/summary' }}}):_vm._e()],1):_vm._e(),(_vm.isAccessReport && _vm.menuShow('menu_report'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_report,
                        icon: 'fa fa-file text-info',
                        path: '/backoffice/reports'
                    }}},[(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_team, icon: 'fa fa-file text-info', path: '/backoffice/reports/team' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_sale_chnanel, icon: 'fa fa-file text-info', path: '/backoffice/reports/sale-channel' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/product' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_user, icon: 'fa fa-file text-info', path: '/backoffice/reports/user' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_user_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/user-product' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_wms_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_wms_product_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-product' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_wms_field_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-field' }}}):_vm._e(),(_vm.isAccessReport && _vm.canViewCost)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_salechannel_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/salechannel-product' }}}):_vm._e(),(_vm.isAccessReport && _vm.canViewCost)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_product_cost, icon: 'fa fa-file text-info', path: '/backoffice/reports/product-cost' }}}):_vm._e(),(_vm.isAccessReport)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_report_order_return, icon: 'fa fa-file text-info', path: '/backoffice/reports/order-return' }}}):_vm._e()],1):_vm._e(),(_vm.isAccessPlatform && _vm.menuShow('menu_platform'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_platform,
                        icon: 'fa fa-database text-info',
                        path: '/platform/tiktok'
                    }}}):_vm._e(),(_vm.isAccessWms && _vm.menuShow('menu_inventory'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_inventory,
                        icon: 'fa fa-database text-info',
                        path: '/wms/inventory'
                    }}},[(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_dashboard,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/dashboard'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/summary'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_list_detail,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/detail'
                        }}}):_vm._e(),(_vm.IsEmployee)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_history,
                            icon: 'fa fa-bullhorn text-info',
                            path: '/wms/history'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_history_storage_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/storage'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_inventory_summary_packing,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/packing'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_return_warehouse,
                            icon: 'fa fa-undo text-info',
                            path: '/wms/inventory/return'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_partner,
                            icon: 'fa fa-id-card text-blue',
                            path: '/wms/partner'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_product,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product'
                        }}}):_vm._e(),(_vm.IsEmployee)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_product_wait_ship,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product/waitship'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_storage,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }}}):_vm._e(),(_vm.isAccessWms)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_shipped_no_deduct,
                            icon: 'fa fa-truck text-warning',
                            path: '/wms/inventory/shipped-no-deduct'
                        }}}):_vm._e()],1):_vm._e(),(_vm.isAccessExpress && _vm.menuShow('menu_express'))?_c('sidebar-item',{attrs:{"link":{
                        name: _vm.menu_express,
                        icon: 'fa fa-cars text-error',
                        path: '/express'
                    }}},[(_vm.isAccessExpress)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_express_list,
                            icon: 'fa fa-tasks text-primary',
                            path: '/express'
                        }}}):_vm._e(),(_vm.isAccessExpress)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_express_form,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }}}):_vm._e()],1):_vm._e(),(_vm.isAdmin && _vm.menuShow('menu_admin'))?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_admin,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin'
                        }}},[(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_user,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin/user'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_platform_connect,
                            path: '/admin/platform'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_sale_channel,
                            path: '/admin/sale-channel'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_admin_product,
                            path: '/admin/product'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_admin_product_v2,
                            path: '/admin/product_platform'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_available_product,
                            path: '/wms/available-product'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_admin_skurandom,
                            path: '/admin/skurandom'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_payment_channel,
                            path: '/admin/payment'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_shipping_config,
                            icon: 'fa fa-truck text-primary',
                            path: '/backoffice/shipping-config'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_stock_forecast,
                            path: '/wms/forecast'
                        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
                            name: _vm.menu_stock_usage,
                            path: '/wms/usage'
                        }}}):_vm._e()],1):_vm._e(),(_vm.isAccessAccount && _vm.menuShow('menu_account'))?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_account,
						icon: 'fa fa-calculator text-success',
						path: '/account'
					}}},[(_vm.isAccessAccount)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_account_records,
							icon: 'fa fa-list',
							path: '/account/records'
						}}}):_vm._e(),(_vm.isAccessAccount)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_account_items,
							icon: 'fa fa-tags',
							path: '/account/items'
						}}}):_vm._e(),(_vm.isAccessAccount)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_account_reports,
							icon: 'fa fa-chart-bar',
							path: '/account/reports'
						}}}):_vm._e()],1):_vm._e(),((_vm.isAccessMember || _vm.isAdmin) && _vm.menuShow('menu_member_admin'))?_c('sidebar-item',{attrs:{"link":{
					name: _vm.menu_member_admin,
					icon: 'fa fa-id-badge text-info'
				}}},[(_vm.isAccessMember)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_member_admin_list,
						path: '/members'
					}}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_member_levels,
						path: '/members/levels'
					}}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_cod_rejections,
						path: '/members/cod-rejections'
					}}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_promo_notification,
						path: '/notification/promo'
					}}}):_vm._e(),(_vm.isAccessMember)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_member_coins_report,
						path: '/members/coins-report'
					}}}):_vm._e()],1):_vm._e(),(_vm.isAccessKOL && _vm.menuShow('menu_kol'))?_c('sidebar-item',{attrs:{"link":{
					name: _vm.menu_kol,
					icon: 'fa fa-star text-warning',
					path: '/kol'
				}}},[(_vm.isAccessKOL)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_kol_creators,
						path: '/kol/creators'
					}}}):_vm._e(),(_vm.isAccessKOL)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_kol_assignments,
						path: '/kol/assignments'
					}}}):_vm._e(),(_vm.isAccessKOL)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_kol_reports,
						path: '/kol/reports'
					}}}):_vm._e(),(_vm.isAccessKOL)?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_kol_payout_batches,
						path: '/kol/payout-batches'
					}}}):_vm._e()],1):_vm._e(),((_vm.isSeller || _vm.isAdmin) && _vm.menuShow('menu_seller'))?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_seller,
						icon: 'fa fa-store text-info',
						path: '/seller'
					}}},[(_vm.isSeller || _vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_seller_orders,
							path: '/seller/orders'
						}}}):_vm._e(),(_vm.isSeller || _vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_seller_payment_report,
							path: '/seller/payment-report'
						}}}):_vm._e()],1):_vm._e(),(_vm.isAccessModernTrade && _vm.menuShow('menu_modern_trade'))?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_modern_trade,
						icon: 'ni ni-building text-teal',
						path: '/modern-trade/companies'
					}}},[(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_mt_sale_orders,
							path: '/modern-trade/sale-orders'
						}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_mt_sales_import,
							path: '/modern-trade/sales-import'
						}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_mt_consignment_payments,
							path: '/modern-trade/consignment-payments'
						}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_mt_invoices,
							path: '/modern-trade/invoices'
						}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_mt_stock,
							path: '/modern-trade/stock'
						}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_mt_settings },"menu":true}},[(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_products,
								path: '/modern-trade/products'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_price_templates,
								path: '/modern-trade/price-templates'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_companies,
								path: '/modern-trade/companies'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_doc_format,
								path: '/modern-trade/doc-format-settings'
							}}}):_vm._e()],1):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_mt_reports },"menu":true}},[(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_report_sales,
								path: '/modern-trade/reports/sales'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_report_stock_value,
								path: '/modern-trade/reports/stock-value'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_expiry_report,
								path: '/modern-trade/expiry-report'
							}}}):_vm._e(),(_vm.isAccessModernTrade)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_mt_expiry_returns,
								path: '/modern-trade/expiry-returns'
							}}}):_vm._e()],1):_vm._e()],1):_vm._e(),(_vm.isPosBO && _vm.menuShow('menu_pos'))?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_pos,
						icon: 'ni ni-cart text-pink',
						path: '/pos/bills'
					}}},[(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_pos_bills,
							path: '/pos/bills'
						}}}):_vm._e(),(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_pos_reports },"menu":true}},[(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_report_sales,
								path: '/pos/reports/sales'
							}}}):_vm._e(),(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_report_top_spenders,
								path: '/pos/reports/top-spenders'
							}}}):_vm._e(),(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_report_products,
								path: '/pos/reports/products'
							}}}):_vm._e(),(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_report_promotions,
								path: '/pos/reports/promotions'
							}}}):_vm._e(),(_vm.isPosBO)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_report_event_members,
								path: '/pos/reports/event-members'
							}}}):_vm._e()],1):_vm._e(),(_vm.isPosBOSupervisor)?_c('sidebar-item',{attrs:{"link":{ name: _vm.menu_pos_settings_group },"menu":true}},[(_vm.isPosBOSupervisor)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_devices,
								path: '/pos/devices'
							}}}):_vm._e(),(_vm.isPosBOAdmin)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_events,
								path: '/pos/events'
							}}}):_vm._e(),(_vm.isPosBOAdmin)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_bundles,
								path: '/pos/products'
							}}}):_vm._e(),(_vm.isPosBOAdmin)?_c('sidebar-item',{attrs:{"link":{
								name: _vm.menu_pos_settings,
								path: '/pos/settings'
							}}}):_vm._e()],1):_vm._e()],1):_vm._e(),((_vm.isAccessMarketing || _vm.isAccessAffiliateFinance) && _vm.menuShow('menu_marketing'))?_c('sidebar-item',{attrs:{"link":{
						name: _vm.menu_marketing,
						icon: 'fa fa-bullhorn text-orange',
						path: _vm.marketingPath
					}}},[(_vm.isAccessMarketing)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_landing_pages,
							path: '/marketing/landing-pages'
						}}}):_vm._e(),(_vm.isAccessMarketing)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_attribution,
							path: '/marketing/reports/attribution'
						}}}):_vm._e(),(_vm.isAccessMarketing)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_referral_codes,
							path: '/marketing/referral-codes'
						}}}):_vm._e(),(_vm.isAccessMarketing)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_referral_report,
							path: '/marketing/reports/referral'
						}}}):_vm._e(),(_vm.isAccessMarketing)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_affiliate_settings,
							path: '/marketing/affiliate/settings'
						}}}):_vm._e(),(_vm.isAccessMarketing || _vm.isAccessAffiliateFinance)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_affiliate_members,
							path: '/marketing/affiliate/members'
						}}}):_vm._e(),(_vm.isAccessMarketing || _vm.isAccessAffiliateFinance)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_affiliate_commissions,
							path: '/marketing/affiliate/commissions'
						}}}):_vm._e(),(_vm.isAccessAffiliateFinance)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_affiliate_payouts,
							path: '/marketing/affiliate/payouts'
						}}}):_vm._e(),(_vm.isAccessMarketing || _vm.isAccessAffiliateFinance)?_c('sidebar-item',{attrs:{"link":{
							name: _vm.menu_marketing_affiliate_report,
							path: '/marketing/reports/affiliate'
						}}}):_vm._e()],1):_vm._e()]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{staticClass:"main-content__page",on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveList,"max":_vm.keepAliveMax}},[_c('router-view',{key:_vm.viewKey})],1)],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }